import $ from 'jquery';

const { registerBlockType } = wp.blocks;
const { RichText, MediaUpload, MediaUploadCheck, URLInputButton } =
  wp.blockEditor;
const { Button, PanelBody } = wp.components;
const { Fragment, useEffect } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { __ } = wp.i18n;
import verticalSlider from '../../../resources/scripts/module/vertical-slider';

registerBlockType('pg/services-slider-section', {
  title: __('PG Services Slider Section'),
  icon: 'images-alt2',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    uniqueSliderId: {
      type: 'string',
      default: '',
    },
    title: {
      type: 'string',
      source: 'html',
      selector: '.content-wrapper > h2',
    },
    slides: {
      type: 'array',
      default: [],
      source: 'query',
      selector: '.slide-container',
      query: {
        h4Text: { type: 'string', source: 'html', selector: 'h4' },
        description: {
          type: 'string',
          source: 'html',
          selector: '.description',
        },
        imgSrc: {
          type: 'string',
          source: 'attribute',
          attribute: 'src',
          selector: '.image-wrapper img',
        },
        imgAlt: {
          type: 'string',
          source: 'attribute',
          attribute: 'alt',
          selector: '.image-wrapper img',
        },
        buttonText: { type: 'string', source: 'text', selector: '.buttons a' },
        buttonHref: {
          type: 'string',
          source: 'attribute',
          attribute: 'href',
          selector: '.buttons a',
        },
      },
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { uniqueSliderId, title, slides } = attributes;

    if (!uniqueSliderId) {
      const newId = 'vertical-slider-' + Math.floor(Math.random() * 1000);
      setAttributes({ uniqueSliderId: newId });
    }

    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    const useSliderInitOnResize = (initSliderFunc) => {
      useEffect(() => {
        // Initialize the slider first without waiting for resize
        initSliderFunc();

        // Debounce the reinitialization function to prevent excessive calls on resize
        const debouncedInit = debounce(() => {
          initSliderFunc();
        }, 250);

        // Add the resize event listener
        window.addEventListener('resize', debouncedInit);

        // Cleanup function to remove the event listener
        return () => {
          window.removeEventListener('resize', debouncedInit);
        };
      }, [initSliderFunc]);
    };

    useSliderInitOnResize(() => {
      if (!slides.length) return;

      verticalSlider();
    });

    const onChangeTitle = (newTitle) => {
      setAttributes({ title: newTitle });
    };

    const onAddSlide = () => {
      const slider = $(`#${uniqueSliderId}`);
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }

      const newSlide = {
        h4Text: 'New Slide Title',
        description: 'New Slide Description',
        imgSrc: '',
        imgAlt: '',
        buttonText: 'Learn More',
        buttonHref: '#',
      };
      setAttributes({ slides: [...slides, newSlide] });
    };

    const onUpdateSlide = (index, field, value) => {
      const slider = $(`#${uniqueSliderId}`);
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }

      const newSlides = slides.map((slide, i) => {
        if (i === index) {
          return { ...slide, [field]: value };
        }
        return slide;
      });
      setAttributes({ slides: newSlides });
    };

    const onRemoveSlide = (index) => {
      const slider = $(`#${uniqueSliderId}`);
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }

      const newSlides = slides.filter((_, i) => i !== index);
      setAttributes({ slides: newSlides });
    };

    const onSelectImage = (index, media) => {
      const newSlides = slides.map((slide, i) => {
        if (i === index) {
          return { ...slide, imgAlt: media.alt, imgSrc: media.url };
        }
        return slide;
      });
      setAttributes({ slides: newSlides });
    };

    return (
      <section className="section-dark-secondary">
        <InspectorControls>
          <PanelBody title={__('Manage Slides')}>
            <Button isSecondary onClick={onAddSlide}>
              + Add Slide
            </Button>
          </PanelBody>
        </InspectorControls>
        <div className="slider-wrapper">
          <div className="slider-container">
            <div className="content-wrapper">
              <RichText
                tagName="h2"
                value={title}
                onChange={onChangeTitle}
                placeholder={__('Enter title here', 'pg')}
              />
              <p className="buttons">
                <button
                  title="Prev"
                  data-slider={uniqueSliderId}
                  data-type="prev"
                  className="btn btn-circle btn-circle-dark btn-angle btn-angle-reverse"
                ></button>
                <button
                  title="Next"
                  data-slider={uniqueSliderId}
                  data-type="next"
                  className="btn btn-circle btn-circle-dark btn-angle"
                ></button>
              </p>
            </div>
            <div className="list-wrapper">
              <div
                id={uniqueSliderId}
                className="list"
                data-slider="vertical-slider"
              >
                {slides &&
                  slides.length &&
                  slides.map((slide, index) => (
                    <Fragment key={index}>
                      <div className="slide-container">
                        <div className="content-wrapper">
                          <Button
                            isPrimary
                            onClick={() => onRemoveSlide(index)}
                            className={'removeButton'}
                          >
                            Remove Slide
                          </Button>
                          <RichText
                            tagName="h4"
                            value={slide.h4Text}
                            onChange={(newText) =>
                              onUpdateSlide(index, 'h4Text', newText)
                            }
                            placeholder={__('Enter slide title here', 'pg')}
                          />
                          <RichText
                            tagName="p"
                            className={'description'}
                            value={slide.description}
                            onChange={(newText) =>
                              onUpdateSlide(index, 'description', newText)
                            }
                            placeholder={__(
                              'Enter slide description here',
                              'pg'
                            )}
                          />
                          <p className={'buttons'}>
                            <a
                              href={'#'}
                              title={slide.buttonText}
                              className={`btn btn-light btn-text`}
                            >
                              <RichText
                                tagName="span"
                                value={slide.buttonText}
                                onChange={(buttonText) =>
                                  onUpdateSlide(index, 'buttonText', buttonText)
                                }
                                keepPlaceholderOnFocus={true}
                              />
                              <URLInputButton
                                url={slide.buttonHref}
                                onChange={(buttonHref) =>
                                  onUpdateSlide(index, 'buttonHref', buttonHref)
                                }
                              />
                            </a>
                          </p>
                        </div>
                        <MediaUploadCheck>
                          <MediaUpload
                            onSelect={(media) => onSelectImage(index, media)}
                            allowedTypes={['image']}
                            render={({ open }) => (
                              <Button
                                className={'addButton'}
                                onClick={open}
                                isPrimary
                              >
                                Upload Image
                              </Button>
                            )}
                          />
                        </MediaUploadCheck>
                        <div className="image-wrapper">
                          {slide.imgSrc && (
                            <img
                              src={slide.imgSrc}
                              alt={slide.imgAlt}
                              style={{ width: '100%' }}
                            />
                          )}
                        </div>
                      </div>
                    </Fragment>
                  ))}
              </div>
            </div>
            <Button className={'addButton'} isPrimary onClick={onAddSlide}>
              + Add Slide
            </Button>
          </div>
        </div>
      </section>
    );
  },
  save: ({ attributes }) => {
    const { uniqueSliderId, title, slides } = attributes;

    return (
      <section className="section-dark-secondary">
        <div className="slider-wrapper">
          <div className="slider-container">
            <div className="content-wrapper">
              <h2>{title}</h2>
              <p className="buttons">
                <button
                  title="Prev"
                  data-slider={uniqueSliderId}
                  data-type="prev"
                  className="btn btn-circle btn-circle-dark btn-angle btn-angle-reverse"
                ></button>
                <button
                  title="Next"
                  data-slider={uniqueSliderId}
                  data-type="next"
                  className="btn btn-circle btn-circle-dark btn-angle"
                ></button>
              </p>
            </div>
            <div className="list-wrapper">
              <div
                id={uniqueSliderId}
                className="list"
                data-slider="vertical-slider"
              >
                {slides &&
                  slides.length &&
                  slides.map((slide, index) => (
                    <div key={index} className="slide-container">
                      <div className="content-wrapper">
                        <h4>{slide.h4Text}</h4>
                        <p className="description">{slide.description}</p>
                        <p className="buttons">
                          <a
                            href={slide.buttonHref}
                            className="btn btn-light btn-text"
                          >
                            {slide.buttonText}
                          </a>
                        </p>
                      </div>
                      <div className="image-wrapper">
                        <img src={slide.imgSrc} alt={slide.imgAlt} />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="gradient"></div>
            </div>
          </div>
        </div>
      </section>
    );
  },
});
